module.exports = __webpack_public_path__ + "static/media/user2.bfd5a41b.gif";